export default "__VITE_ASSET__62835b4c__"